((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	// ＜ルート設定対応＞要素が空だったら削除
	const removeElmIfEmpty = () => {
		const $eleList = document.querySelectorAll('.js-checkEmptyElm');
		$eleList.forEach(ele => {
			if (!ele.textContent.trim().length) {
				ele.classList.add('di_none');
			}
		});
	}
	// ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
	const removeBlockIfListEmpty = () => {
		const $eleList = document.querySelectorAll('.js-checkEmptyList');
		if ($eleList) {
			$eleList.forEach(ele => {
				if (!ele.getElementsByTagName('li').length) {
					ele.closest('.js-checkEmptyList-wrap').classList.add('di_none');
				}
			});
		}
	};
	const slider = () => {
		// newway_newvaluw記事スライダー3カラム
		if(document.querySelectorAll('.mod-slider01').length) {
			new Swiper('.mod-slider01', {
				slidesPerView: 1,
				spaceBetween: 0,
				// loop: true,
				// loopAdditionalSlides: 1,
				speed: 1000,
				autoplay: false,
				watchSlidesProgress: true,
				navigation: {
					nextEl: '.mod-slider01-control .swiper-button-next',
					prevEl: '.mod-slider01-control .swiper-button-prev',
				},
				breakpoints: {
				  1024: {
					slidesPerView: 3,
				  },
				},
			});
			setTimeout(() => { 
				const $elements = document.querySelectorAll( '[data-mh]' );
				const groups = new Map();
	
				$elements.forEach( ele => { ele.style.height = 'auto'; } ); // 初期化
	
				$elements.forEach( ele => {
					const attributeName = ele.getAttribute( 'data-mh' );
					if ( !groups.has( attributeName ) ) {
						groups.set( attributeName, [] );
					}
					groups.get( attributeName ).push( ele );
				} );
				groups.forEach( group => {
					const attributeGroups = new Map();
					group.forEach( ele => {
						const attributeName = ele.getAttribute( 'data-mh' );
						const topPosition = ele.getBoundingClientRect().top;
						const key = attributeName + '_' + topPosition;
						if ( !attributeGroups.has( key ) ) {
							attributeGroups.set( key, [] );
						}
						attributeGroups.get( key ).push( ele );
					} );
					attributeGroups.forEach( (item) => {
						const maxHeight = Math.max( ...item.map( ele => ele.offsetHeight ) );
						item.forEach( (ele2) => {
							ele2.style.height = `${maxHeight}px`;
						});
					});
				} );
			 }, 300);
		}
	};
	const searchKeyword = () => {
		if(document.querySelectorAll('.js-search-keyword').length) {
			let $form = document.querySelector('.js-search-keyword');
			let $kinput = document.querySelector('.js-search-keyword-input');
			let $btn = document.querySelector('.js-search-keyword-button');
			const formSubmit = () => {
				if($kinput.value) {
					let karray = $kinput.value.replaceAll(/[\"]/g,"").normalize("NFKC").split(/\s/);
					karray.forEach((eleK,idxK) => {
						console.log(eleK,idxK);
						let keywordInputs = '';
						let keywordInputs2 = '';
						if(idxK == 0) {
							keywordInputs = '<input name="p_keywords_1" type="hidden" value="'+eleK+'" />';
							$form.insertAdjacentHTML('afterbegin', keywordInputs);
							keywordInputs2 = '<input name="p_block_1" type="hidden" value="'+eleK+'" />';
							$form.insertAdjacentHTML('afterbegin', keywordInputs2);
						} else if(idxK == 1) {
							keywordInputs = '<input name="p_keywords_2" type="hidden" value="'+eleK+'" />';
							$form.insertAdjacentHTML('afterbegin', keywordInputs);
							keywordInputs2 = '<input name="p_block_2" type="hidden" value="'+eleK+'" />';
							$form.insertAdjacentHTML('afterbegin', keywordInputs2);
						} else if(idxK == 2) {
							keywordInputs = '<input name="p_keywords_3" type="hidden" value="'+eleK+'" />';
							$form.insertAdjacentHTML('afterbegin', keywordInputs);
							keywordInputs2 = '<input name="p_block_3" type="hidden" value="'+eleK+'" />';
							$form.insertAdjacentHTML('afterbegin', keywordInputs2);
						} else if(idxK == 3) {
							keywordInputs = '<input name="p_keywords_4" type="hidden" value="'+eleK+'" />';
							$form.insertAdjacentHTML('afterbegin', keywordInputs);
							keywordInputs2 = '<input name="p_block_4" type="hidden" value="'+eleK+'" />';
							$form.insertAdjacentHTML('afterbegin', keywordInputs2);
						} else if(idxK == 4) {
							keywordInputs = '<input name="p_keywords_5" type="hidden" value="'+eleK+'" />';
							$form.insertAdjacentHTML('afterbegin', keywordInputs);
							keywordInputs2 = '<input name="p_block_5" type="hidden" value="'+eleK+'" />';
							$form.insertAdjacentHTML('afterbegin', keywordInputs2);
						} else if(idxK == 5) {
							keywordInputs = '<input name="p_keywords_6" type="hidden" value="'+eleK+'" />';
							$form.insertAdjacentHTML('afterbegin', keywordInputs);
							keywordInputs2 = '<input name="p_block_6" type="hidden" value="'+eleK+'" />';
							$form.insertAdjacentHTML('afterbegin', keywordInputs2);
						}
					});
				}
				$form.submit();
				return false;
			};
			// 初期表示パラメータを見てvalue入れ込み
			let urlParam = location.search.substring(1);
			let paramArray = [];
			if(urlParam) {
				let param = urlParam.split('&');
				for(let i = 0; i < param.length; i++) {
					let paramItem = param[i].split('=');
					paramArray[paramItem[0]] = paramItem[1];
				}
			}
			let kewordValue = '';
			if(paramArray.p_keywords_1) {
				kewordValue += (paramArray.p_keywords_1 + ' ');
			}
			if(paramArray.p_keywords_2) {
				kewordValue += (paramArray.p_keywords_2 + ' ');
			}
			if(paramArray.p_keywords_3) {
				kewordValue += (paramArray.p_keywords_3 + ' ');
			}
			if(paramArray.p_keywords_4) {
				kewordValue += (paramArray.p_keywords_4 + ' ');
			}
			if(paramArray.p_keywords_5) {
				kewordValue += (paramArray.p_keywords_5 + ' ');
			}
			if(paramArray.p_keywords_6) {
				kewordValue += (paramArray.p_keywords_6 + ' ');
			}
			$kinput.value = decodeURI(kewordValue);
			$kinput.addEventListener("keydown", (e) => {
				if(e.keyCode === 13){
					formSubmit();
				}
			});
			$btn.addEventListener('click', () => {
				formSubmit();
			});
		}
	};
	const corporateGroupDetailNews = () => {
		// 関連新着情報(/jp/corporate/group/template_detail.html)
		if(document.querySelectorAll('.js-corporate-group-detail-news').length) {
			let _id = document.querySelector('.js-corporate-group-detail-news').querySelector('.rt_cf_co_business_key').textContent;
			let lang = location.pathname.split('/')[1];
			const getJSONfiles = () => {
				return `/${lang}/ajax/corporate/group/related_news/${_id}.json`;
			};
			fetch(getJSONfiles()).then(function (data) {
				return data.json();
			}).then(function (data) {
				const bytesToSize = (bytes) => {
					var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
					if (bytes === 0) {
						return 'n/a';
					}
					var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
					if (i === 0) {
						return bytes + ' ' + sizes[i];
					}
					return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
				}
				// console.log(data,'tada');
				let HTML = '';
				if(data.rt_bn_news.length) {
					data.rt_bn_news.forEach(function(val, index){
						let _link = '';
						if(!val.rt_cf_n_icon_blank) {
							if(!val.rt_cf_n_attachment_file_icon_pdf) {
								if(val.rt_cf_n_href.href == '#') {
									_link = `<div class="mod-newsList-item-link" style="pointer-events:none;">
										<p>${val.rt_cf_n_title.content[0]}</span></p>
									</div>`;
								} else {
									if(val.rt_cf_n_href.target == '_blank') {
										_link = `<a href="${val.rt_cf_n_href.href}" target="_blank" class="mod-newsList02-item-link">
											<p>${val.rt_cf_n_title.content[0]}</p>
										</a>`;
									} else {
										_link = `<a href="${val.rt_cf_n_href.href}" class="mod-newsList-item-link">
											<p>${val.rt_cf_n_title.content[0]}</p>
										</a>`;
									}
								}
							} else {
								_link = `<a href="${val.rt_cf_n_href.href}" target="_blank" class="mod-newsList-item-link">
									<svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#pdf" /></svg>
									<p>${val.rt_cf_n_title.content[0]} [PDF:<span class="">${bytesToSize(val.rt_cf_n_attachment_file_size.content)}</span>]</p>
								</a>`;
							}
						} else {
							_link = `<a href="${val.rt_cf_n_href.href}" target="_blank" class="mod-newsList-item-link">
								<p>${val.rt_cf_n_title.content[0]}<svg aria-hidden="true" class="rt_cf_n_icon_blank"><use xlink:href="/common/svg/sprite.svg#blank" /></svg></p>
							</a>`;
						}
						HTML += `<li class="mod-newsList-item">
							<p class="mod-newsList-item-day ff_lato">${val.rt_cf_n_date.content}</p>
							<p class="mod-newsList-item-category">${val.rt_cf_n_category_name.content[0]}</p>
							${_link}
						</li>`;
				 	});
					document.querySelector('.js-corporate-group-detail-news-list').insertAdjacentHTML('beforeend', HTML);
					document.querySelector('.js-corporate-group-detail-news').classList.remove('di_none');
				}
			});
		}
	}
	const corporateGroupBox = () => {
		// 関連新着情報(/jp/corporate/group/(business|area)/template.html)
		if(document.querySelectorAll('.js-corporate-group-box').length) {
			document.querySelectorAll('.js-corporate-group-box').forEach(function(val, index){
				// console.log(val.querySelector('.detail_button_checker').querySelectorAll('span').length,'aaa');
				if(val.querySelector('.detail_button_checker').querySelectorAll('span').length) {
					val.querySelector('.corporate-group-box01-link').classList.remove('di_none');
				}
			});
		}
	}
	removeElmIfEmpty();
	removeBlockIfListEmpty();
	slider();
	searchKeyword();
	corporateGroupDetailNews();
	corporateGroupBox();
})(window.FUNCTIONS);
